var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountNewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 10C1.66675 7.82881 1.66675 6.7432 1.94445 5.86245C2.5331 3.99547 3.99553 2.53304 5.86251 1.94439C6.74326 1.66669 7.82887 1.66669 10.0001 1.66669C12.1713 1.66669 13.2569 1.66669 14.1376 1.94439C16.0046 2.53304 17.4671 3.99547 18.0557 5.86245C18.3334 6.7432 18.3334 7.82881 18.3334 10C18.3334 12.1712 18.3334 13.2568 18.0557 14.1376C17.4671 16.0046 16.0046 17.467 14.1376 18.0557C13.2569 18.3334 12.1713 18.3334 10.0001 18.3334C7.82887 18.3334 6.74326 18.3334 5.86251 18.0557C3.99553 17.467 2.5331 16.0046 1.94445 14.1376C1.66675 13.2568 1.66675 12.1712 1.66675 10Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1112 10.8334H8.88897C7.66167 10.8334 6.66675 11.8283 6.66675 13.0556C6.66675 13.6692 7.16421 14.1667 7.77786 14.1667H12.2223C12.836 14.1667 13.3334 13.6692 13.3334 13.0556C13.3334 11.8283 12.3385 10.8334 11.1112 10.8334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66669C11.6667 7.58716 10.9206 8.33335 10.0001 8.33335C9.07961 8.33335 8.33341 7.58716 8.33341 6.66669C8.33341 5.74621 9.07961 5.00002 10.0001 5.00002C10.9206 5.00002 11.6667 5.74621 11.6667 6.66669Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountNewIcon);
export default ForwardRef;